import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { T, SECTIONS_ORDER } from "../i18n/strings";

export default function Footer() {
  const { lang } = useLanguage();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#081422] text-[#FAF8F5] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 border-2 border-[#C5A059] pw-mullion" aria-hidden />
              <h3 className="font-serif-display text-2xl font-bold">
                POLITICAL <span className="text-[#C5A059]">WINDOW</span>
              </h3>
            </div>
            <p className="font-serif-body text-[#94A3B8] mt-4 max-w-md text-base leading-relaxed">
              {T.labels.windowMotto[lang]}
            </p>
            <p className="font-mono-meta text-[0.7rem] uppercase tracking-widest text-[#C5A059] mt-6">
              {T.edition[lang]}
            </p>
          </div>

          <div>
            <h4 className="font-mono-meta text-[0.7rem] uppercase tracking-widest text-[#C5A059] mb-4">
              {T.labels.section[lang]}
            </h4>
            <ul className="space-y-2 font-sans-ui text-sm">
              {SECTIONS_ORDER.map((s) => (
                <li key={s}>
                  <Link to={`/section/${s}`} className="text-[#94A3B8] hover:text-[#C5A059] transition-colors" data-testid={`footer-nav-${s}`}>
                    {T.nav[s][lang]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-mono-meta text-[0.7rem] uppercase tracking-widest text-[#C5A059] mb-4">
              {T.labels.editorial[lang]}
            </h4>
            <ul className="space-y-2 font-sans-ui text-sm">
              <li><Link to="/about" className="text-[#94A3B8] hover:text-[#C5A059] transition-colors" data-testid="footer-about">{T.labels.about[lang]}</Link></li>
              <li><Link to="/contact" className="text-[#94A3B8] hover:text-[#C5A059] transition-colors" data-testid="footer-contact">{T.labels.contact[lang]}</Link></li>
              <li><Link to="/privacy" className="text-[#94A3B8] hover:text-[#C5A059] transition-colors" data-testid="footer-privacy">{T.labels.privacy[lang]}</Link></li>
              <li><Link to="/terms" className="text-[#94A3B8] hover:text-[#C5A059] transition-colors" data-testid="footer-terms">{T.labels.terms[lang]}</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#1E3A5F] mt-12 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 font-mono-meta text-[0.7rem] uppercase tracking-widest text-[#64748B]">
          <span>© {year} POLITICAL WINDOW · Janela Política</span>
          <span>ISSN 0000-0000 (illustrative)</span>
        </div>
      </div>
    </footer>
  );
}
